import { Action } from '@ngrx/store';
import {NoActivitiesRedirect} from '../../auth/actions/auth.actions';

// Constants - General
export const GET_PROJECT = '[Project] Get Project';
export const GET_PROJECT_BY_LANGUAGE = '[Project] Get Project By Language';
export const GET_PROJECT_SUCCESS = '[Project] Get Project Success';
export const GET_WELCOME_MESSAGE = '[Project] Get Welcome Message';
export const GET_WELCOME_MESSAGE_SUCCESS = '[Project] Get Welcome Message Success';
export const GET_FOCUS_PROMPT = '[Project] Get Focus Prompt';
export const GET_FOCUS_PROMPT_SUCCESS = '[Project] Get Focus Prompt Success';
export const TOOGLE_UPLOAD_FILE_SUCCESS_STATE = '[Project] Toogle Upload File Success State';
export const UPLOAD_INFORMED_CONSENT_FILE = '[My Projects] Upload Informed Consent File';
export const UPLOAD_INFORMED_CONSENT_FILE_SUCCESS = '[My Projects] Upload Informed Consent File Success';
export const ACCEPT_INFORMED_CONSENT_SUCCESS = '[My Projects] Accept Informed Consent Success';
export const TOOGLE_ACCEPT_INFORMED_CONSENT_SUCCESS = '[My Projects] Toogle Accept Informed Consent Success';
export const ACCEPT_INFORMED_CONSENT = '[My Projects] Accept Informed Consent';
export const DISABLE_TYM_MODAL = '[My Projects] Disable Thank Yuo Message Modal';
export const DISABLE_TYM_MODAL_SUCCESS = '[My Projects] Disable Thank Yuo Message Modal Success';
export const SHOW_WELCOME_MESSAGE = '[Project] Show Welcome Message';
export const EXIT_PREVIEW_MODE = '[Project] Exit Preview Mode';
export const GET_AVAILABLE_LANGUAGE = '[Auth] Get Available language';
export const GET_AVAILABLE_LANGUAGE_SUCCESS = '[Auth] Get Available language Success';
export const GET_IC_BY_LANGUAGE = '[Project] Get IC by language';
export const GET_IC_BY_LANGUAGE_SUCCESS = '[Project] Get IC by language Success';
export const GET_DEFAULT_LANGUAGE = '[Project] Get project default language';
export const GET_DEFAULT_LANGUAGE_SUCCESS = '[Project] Get project default language Success';

// Actions - General
export class GetProject implements Action {
  readonly type = GET_PROJECT;
  constructor(public payload: number) {}
}
// Actions - General
export class GetProjectByLanguage implements Action {
  readonly type = GET_PROJECT_BY_LANGUAGE;
  constructor(public payload: any) {}
}
export class GetAvailableLanguage implements Action {
  readonly type = GET_AVAILABLE_LANGUAGE;
  constructor(public payload: number) {}
}
export class GetAvailableLanguageSuccess implements Action {
  readonly type = GET_AVAILABLE_LANGUAGE_SUCCESS;
  constructor(public payload: any) {}
}
export class ToogleUploadFileSuccessState implements Action {
  readonly type = TOOGLE_UPLOAD_FILE_SUCCESS_STATE;
}
export class GetProjectSuccess implements Action {
  readonly type = GET_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class GetWelcomeMessage implements Action {
  readonly type = GET_WELCOME_MESSAGE;
  constructor(public payload: any) {}
}
export class GetWelcomeMessageSuccess implements Action {
  readonly type = GET_WELCOME_MESSAGE_SUCCESS;
  constructor(public payload: any) {}
}
export class GetFocusPrompt implements Action {
  readonly type = GET_FOCUS_PROMPT;
  constructor(public payload: any) {}
}
export class GetFocusPromptSuccess implements Action {
  readonly type = GET_FOCUS_PROMPT_SUCCESS;
  constructor(public payload: any) {}
}
export class GetICByLanguage implements Action {
  readonly type = GET_IC_BY_LANGUAGE;
  constructor(public payload: any) {}
}
export class GetICByLanguageSuccess implements Action {
  readonly type = GET_IC_BY_LANGUAGE_SUCCESS;
  constructor(public payload: any) {}
}
export class UploadInformedConsentFile implements Action {
  readonly type = UPLOAD_INFORMED_CONSENT_FILE;
  constructor(public payload: any) {}
}
export class UploadInformedConsentFileSuccess implements Action {
  readonly type = UPLOAD_INFORMED_CONSENT_FILE_SUCCESS;
}
export class DisableTYMModal implements Action {
  readonly type = DISABLE_TYM_MODAL;
  constructor(public payload: number) {}
}
export class DisableTYMModalSuccess implements Action {
  readonly type = DISABLE_TYM_MODAL_SUCCESS;
}
export class AcceptInformedConsentSuccess implements Action {
  readonly type = ACCEPT_INFORMED_CONSENT_SUCCESS;
}
export class ToogleAcceptInformedConsentSuccess implements Action {
  readonly type = TOOGLE_ACCEPT_INFORMED_CONSENT_SUCCESS;
}
export class AcceptInformedConsent implements Action {
  readonly type = ACCEPT_INFORMED_CONSENT;
  constructor(public payload: any) {}
}
export class ShowWelcomeMessage implements Action {
  readonly type = SHOW_WELCOME_MESSAGE;
  constructor(public payload: boolean) {}
}

export class ExitPreviewMode implements Action {
  readonly type = EXIT_PREVIEW_MODE;
}
export class GetDefaultLanguage implements Action {
  readonly type = GET_DEFAULT_LANGUAGE;
  constructor(public payload: number) {}
}
export class GetDefaultLanguageSuccess implements Action {
  readonly type = GET_DEFAULT_LANGUAGE_SUCCESS;
  constructor(public payload: any) {}
}
// Export Actions
 export type Actions =
   | GetProject
   | GetProjectSuccess
   | GetWelcomeMessage
   | GetWelcomeMessageSuccess
   | GetFocusPrompt
   | GetFocusPromptSuccess
   | ToogleUploadFileSuccessState
   | UploadInformedConsentFile
   | UploadInformedConsentFileSuccess
   | AcceptInformedConsentSuccess
   | ToogleAcceptInformedConsentSuccess
   | AcceptInformedConsent
   | DisableTYMModal
   | DisableTYMModalSuccess
   | ShowWelcomeMessage
   | GetAvailableLanguage
   | GetAvailableLanguageSuccess
   | ExitPreviewMode
   | GetProjectByLanguage
   | GetICByLanguage
   | GetICByLanguageSuccess
   | GetDefaultLanguage
   | GetDefaultLanguageSuccess;



// WEBPACK FOOTER //
// ./src/app/project/actions/project.actions.ts